// Module
var code = `<ex-mono-occurrence-ecran formulaire="vm.formulaireUno" largeur-formulaire="50"> <ex-mono-occurrence-ecran-droite> <ex-card-saisie name="infoFin" formulaire="vm.formulaireInfoFin"></ex-card-saisie> </ex-mono-occurrence-ecran-droite> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;